import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { requestWithToken } from 'src/config';

@Injectable({
    providedIn: 'root'
})
export class ProductListingService {
    debounce(callback: (...args: any[]) => void, delay: number): (...args: any[]) => void {
        let timeoutId: any;

        return (...args: any[]): void => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            callback(...args);
          }, delay);
        };
      }
    async getProductListing(searchLike: string, page: number, size: number, filter: any) {
        const p = {
            start: (page - 1) * size,
            size,
            searchLike,
            ...filter
        }
        function createGetRequestUrl(baseUrl: string, params: any) {
            // Create a new URLSearchParams object
            const urlParams = new URLSearchParams();

            // Loop through the parameters and add them to the URLSearchParams
            for (const key in params) {
                if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && params[key] !== "") {
                    urlParams.append(key, params[key]);
                }
            }

            // Combine the base URL and the parameters
            const fullUrl = baseUrl + (urlParams.toString() ? `?${urlParams.toString()}` : '');

            return fullUrl;
        }

        return requestWithToken(
            "GET",
            createGetRequestUrl(`/admin/products`, p),
        )
    }

    async getProductsListing(searchLike: string, page: number, size: number, filter: any) {
        const p = {
            start: (page - 1) * size,
            size,
            ...(searchLike && searchLike.trim() !== '' ? { searchLike } : {}),
            ...filter
        }
        
        return requestWithToken(
            "POST",
            `/admin/productlisting`, p,
        )
    }

    async getProductById(id: number) {
        return requestWithToken(
            "GET",
            `/admin/product/${id}`
        )
    }

    async addProductToFavorites(productVariantId: number, type: number) {
        return requestWithToken(
            "PUT",
            `/admin/product/tooglefavourite/${productVariantId}/${type}`,
            {}
        )
    }

    async getProductCategories() {
        return requestWithToken(
            "GET",
            `/masters/prodCategory`
        )
        // return requestWithToken(
        //     "GET",
        //     `/masters/businessCategory`
        // )
    }
    async getBusinessCategories() {
        return requestWithToken(
            "GET",
            `/masters/businessCategory`
        )
    }

    async getAvailableBranch() {
        return requestWithToken(
            "GET",
            `/user/available-branches`
        )
    }

    async getProductSubCategories(catId: string) {
        return requestWithToken(
            "GET",
            `/masters/subCategory?catId=${catId}`
        )
    }

    async getSubCategoryVarients(subCatId: string) {
        return requestWithToken(
            "GET",
            `/masters/subCategoryVariants?subCatId=${subCatId}`
        )
    }

    async getVarientOptions(variantId: string) {
        return requestWithToken(
            "GET",
            `/masters/variantOptions?variantId=${variantId}`
        )
    }
    async getProductTypes() {
        return requestWithToken(
            "GET",
            `/masters/prodType`
        )
    }
    async getProdEntityType() {
        return requestWithToken(
            "GET",
            `/masters/prodEntityType`
        )
    }

    async getPackageType() {
        return requestWithToken(
            "GET",
            `/masters/packType`
        )
    }
    async getDelDistance() {
        return requestWithToken(
            "GET",
            `/masters/delDistance`
        )
    }
    async getWeightUnits() {
        return requestWithToken(
            "GET",
            `/masters/weightUnit`
        )
    }
    async getProductStatus() {
        return requestWithToken(
            "GET",
            `/masters/prodStatus`
        )
    }
    async getProductStatusForBusiness(){
        return requestWithToken(
            "GET",
            `/admin/businessstatus`
        )
    }
    async getProductApproval() {
        return requestWithToken(
            "GET",
            `/masters/prodApprove`
        )
    }
    async getStockStatus() {
        return requestWithToken(
            "GET",
            `/masters/stockStatus`
        )
    }
    async getServiceType() {
        return requestWithToken(
            "GET",
            `/masters/serviceType`
        )
    }
    async getServiceDuration() {
        return requestWithToken(
            "GET",
            `/masters/duration`
        )
    }
    async uploadFile(payload: any) {
        return requestWithToken(
            "POST",
            "/user/document",
            payload
        )
    }
    async saveProduct(payload: any) {
        return requestWithToken(
            "POST",
            "/admin/product/save",
            payload
        )
    }
    async deleteVarient(varientId: number) {
        return requestWithToken(
            "DELETE",
            `/admin/product/variant/${varientId}`
        )
    }
    async deleteProduct(productId: number) {
        return requestWithToken(
            "DELETE",
            `/admin/product/${productId}`
        )
    }
    async approveProduct(productId: number) {
        return requestWithToken(
            "PUT",
            `/admin/product/status?status=Approve&productId=${productId}`
        )
    }
    async rejectProduct(productId: number) {
        return requestWithToken(
            "PUT",
            `/admin/product/status?status=Reject&productId=${productId}`
        )
    }

    async getBusinessList(params:any){
        function createGetRequestUrl(baseUrl: string, params: any) {
            // Create a new URLSearchParams object
            const urlParams = new URLSearchParams();

            // Loop through the parameters and add them to the URLSearchParams
            for (const key in params) {
                if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && params[key] !== "") {
                    urlParams.append(key, params[key]);
                }
            }

            // Combine the base URL and the parameters
            const fullUrl = baseUrl + (urlParams.toString() ? `?${urlParams.toString()}` : '');

            return fullUrl;
        }
        return requestWithToken(
            "GET",
            createGetRequestUrl(`/admin/master/business`, params)
        )
    }


    async statusUpdate(productId: number, status:string) {
        return requestWithToken(
            "PUT",
            `/admin/product/${productId}/status/${status}`
        )
    }
}
